module.exports = __webpack_public_path__ + "media/images/lb/731-b2935d99deda3ca62ed3e737cd7b32ce.svg";